import styled from "styled-components";
import { CssRule } from "../../../themes/architecture/css-helpers/css-rule";
import { styledByTheme } from "../../../themes/architecture/styled-by-theme";
import { UserMenuTitleBox } from "../../user-menu/user-menu/boxes/user-menu-title.box";

/**
 * For the title used inside the account box there are a few additional rules needed.
 */
const UserMenuTitleAccountDefaultBox = styled(UserMenuTitleBox)`
    /* .account-box .user-menu-box-title */
    margin: 1rem 0;
    font-weight: 700;

    ${CssRule.For.mobile.build()} &{
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
        margin: 0;
    }
`;

/* 777 */
const UserMenuTitleAccountCasino777Box = styled(UserMenuTitleAccountDefaultBox)`
    margin: 3rem 0 1rem 0;
    color: ${({theme}) => theme.colors.textLight};

    ${CssRule.For.mobile.build()} &{
        font-weight: 400;
    }
`;

const UserMenuTitleAccountMrGreenBox = styled(UserMenuTitleAccountDefaultBox)`
    color: ${({theme}) => theme.colors.textLight};
`;

export const UserMenuTitleAccountBox = styledByTheme(UserMenuTitleAccountDefaultBox)
    .forMrGreen(UserMenuTitleAccountMrGreenBox)
    .forCasino777(UserMenuTitleAccountCasino777Box)
    .apply();
